/** このcomponentはサインイン直後に表示されるダミーページです。
 *  role.guardでsmile9ロールを判定した後、すぐに別ページへ遷移します。
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
